import { getCurrentUser, getCookie } from './utils';

export async function getAuditfileImports(user_cases) {
  const response = await fetch('/import_auditfile/findByCases', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ user_cases }),
  });
  if (response.ok) return response.json();
  return [];
}

export async function deleteAuditfileImport(id) {
  await fetch(`/import_auditfile/delete?id=${id}`);
}

export async function handleAuditfileImport({ entiteit, fileName, file, periodMode, effectiveDateJournals = null }) {
  const user_id = await getCurrentUser();
  const formData = new FormData();
  formData.append('file', file, fileName);
  formData.append('entiteit', entiteit);
  formData.append('fileName', fileName);
  formData.append('user_id', user_id);
  formData.append('periodMode', periodMode || 'default');
  if (effectiveDateJournals !== null) {
    formData.append('effectiveDateJournals', JSON.stringify(effectiveDateJournals));
  }

  const response = await fetch('/auditfile/handleImport', {
    method: 'POST',
    body: formData,
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.message || `Import mislukt (${response.status})`);
  }
  return response.json();
}

export async function handleAuditfileFinal(entries) {
  const user_id = await getCurrentUser();
  const response = await fetch('/auditfile/handleFinal', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ entries, user_id }),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.message || `handleFinal mislukt (${response.status})`);
  }
  return response.json();
}

export async function resetAuditfileStatus() {
  await fetch('/auditfile/resetStatus');
}
